export const decideVoiceTurn = (caption, pcmMs, speechMs, minAudioMs = 1200, minSpeechMs = 1200) => {
  const hasCaption = Boolean(String(caption || '').trim());
  const usePcm = pcmMs >= minAudioMs;
  return {
    submit: usePcm && (hasCaption || speechMs >= minSpeechMs),
    usePcm,
  };
};

export const pcmFrameHasVoice = (buf, noiseFloor = 0) => {
  if (!buf || buf.byteLength < 2) return false;
  const view = new DataView(buf);
  const samples = Math.floor(buf.byteLength / 2);
  let peak = 0;
  let sum = 0;
  for (let i = 0; i < samples; i += 1) {
    const value = Math.abs(view.getInt16(i * 2, true)) / 32768;
    peak = Math.max(peak, value);
    sum += value;
  }
  const average = sum / samples;
  const floor = Number.isFinite(noiseFloor) ? Math.max(0, noiseFloor) : 0;
  const normalSpeech = peak >= Math.max(0.012, floor * 5)
    && average >= Math.max(0.0008, floor * 1.4);
  const quietSpeech = floor <= 0.0015 && peak >= 0.0075
    && average >= Math.max(0.0015, floor * 2.5);
  return normalSpeech || quietSpeech;
};

export const shouldFinalizeSparseNoCaption = (pcmMs, activeMs, lastVoiceAgoMs) => (
  pcmMs >= 30000 && activeMs >= 450 && activeMs / pcmMs < 0.35
  && lastVoiceAgoMs >= 5000
);

export const voiceSilenceRemaining = (now, lastSpeechAt, lastCaptionAt, silenceMs = 5000) =>
  Math.max(0, silenceMs - (now - Math.max(lastSpeechAt || 0, lastCaptionAt || 0)));

export const VOICE_REPEAT_PROMPT = "I couldn't hear that clearly. Could you say that again?";
export const MAX_VOICE_CLARIFICATIONS = 2;

export const withVoiceDeadline = (promise, timeoutMs = 120000) => new Promise((resolve, reject) => {
  const timer = setTimeout(() => {
    const error = new Error('Your answer is saved. Checking whether delivery completed.');
    error.code = 'delivery_unconfirmed';
    reject(error);
  }, timeoutMs);
  Promise.resolve(promise).then(resolve, reject).finally(() => clearTimeout(timer));
});

export const describeVoiceFailure = (error) => {
  if (![422, 503].includes(error?.status)
      || !/no_speech|unclear_audio|speech_service_unavailable/.test(error.code || error.message || '')) return null;
  const captureFailure = error.reason === 'no_usable_speech' || error.code === 'no_speech';
  const keepAudio = !captureFailure && (error.audioRetained || error.status === 503);
  return {
    keepAudio,
    message: captureFailure
      ? 'We could not detect usable microphone audio. Check your device or browser microphone settings, then retry. You can also type your answer.'
      : keepAudio
        ? 'We could not verify the transcription. Your audio is saved. Retry processing or type your answer.'
        : 'We could not transcribe that answer. Please retry or type your answer.',
  };
};
